import React from "react";
import CustomSelect from "../../components/common/Select";
import { toast } from "react-toastify";
import "../../styles/main.css";
import { Button, Form } from "antd";
import { VEHICLE_TYPES } from "../../constants/Enums";

const vehicleType = ({ setVehicleType, vehicleType, handleStepChange, data, setData }) => {
  const handleSelect = (value) => {
    setVehicleType(value);
    setData({ ...data, size: value });
  };

  const handleNext = () => {
    if (vehicleType === "") {
      toast.error("Select a vehicle type");
      return;
    }
    handleStepChange(2);
  };

  const options = [
    { label: "20FT Flat Bed", value: VEHICLE_TYPES["20FT Flat Bed"] },
    { label: "40FT Flat Bed", value: VEHICLE_TYPES["40FT Flat Bed"] },
    { label: "20FT Containerized Truck", value: VEHICLE_TYPES["20FT Containerized Truck"] },
    { label: "40FT Containerized Truck", value: VEHICLE_TYPES["40FT Containerized Truck"] },
    { label: "20FT Closed Body Truck", value: VEHICLE_TYPES["20FT Closed Body Truck"] },
    { label: "24FT Closed Body Truck", value: VEHICLE_TYPES["24FT Closed Body Truck"] },
    { label: "32FT Closed Body Truck", value: VEHICLE_TYPES["32FT Closed Body Truck"] },
    { label: "Low Loader", value: VEHICLE_TYPES["Low Loader"] },
    { label: "Open Body Truck", value: VEHICLE_TYPES["Open Body Truck"] },
    { label: "Reefer Truck", value: VEHICLE_TYPES["Reefer Truck"] },
  ];

  return (
    <div className="vehicle-form">
      <h2>Vehicle Type</h2>
      <Form layout="vertical">
        <Form.Item label="Choose Type" className="label">
          <div className="selectContainer2">
            <CustomSelect
              options={options}
              size="large"
              handleChange={handleSelect}
              value={vehicleType}
              bordered={false}
            />
          </div>
          <div className="buttons">
            <Button className="b2 alt-button" size={"large"} onClick={() => handleStepChange(0)}>
              Back
            </Button>
            <Button className=" all-button b2" type="primary" size={"large"} onClick={handleNext}>
              Next
            </Button>
          </div>
        </Form.Item>
      </Form>
    </div>
  );
};

export default vehicleType;
